import React from "react";
import logo from "./wogo.png";

const SignIn = ({ signInWithGoogle }) => {
  const handleCreateAccount = () => {
    signInWithGoogle();
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f3f4f6", // Tailwind gray-100 equivalent
        padding: "1rem",
      }}
    >
      <div
        style={{
          textAlign: "center",
          backgroundColor: "white",
          padding: "2.5rem",
          borderRadius: "1rem",
          boxShadow: "0 10px 15px rgba(0,0,0,0.1)",
          maxWidth: "400px",
          width: "100%",
        }}
      >
        <img
          src={logo}
          alt="App Logo"
          style={{
            width: "192px",
            height: "192px",
            objectFit: "contain",
            margin: "0 auto 1.5rem auto",
            display: "block",
          }}
        />
        <h1 style={{ fontSize: "1.875rem", fontWeight: "600", marginBottom: "0.5rem" }}>
          WonOf1 CFB Stock Market
        </h1>
        <p style={{ color: "#4b5563", marginBottom: "1.5rem" }}>
          Start investing in your favorite teams!
        </p>
        <button
          onClick={handleCreateAccount}
          style={{
            padding: "0.75rem 1.5rem",
            backgroundColor: "#2563eb", // Tailwind blue-600
            color: "white",
            borderRadius: "0.5rem",
            fontSize: "1.125rem",
            cursor: "pointer",
            border: "none",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#1d4ed8")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#2563eb")}
        >
          Create Account
        </button>
      </div>
    </div>
  );
};

export default SignIn;
